export default "__VITE_ASSET__CIXShg_m__"